// DockLevelersDialog.tsx — Up to 3 dock leveler blockouts (dlvar)

import DialogBase from './DialogBase';
import { SlotEditor } from './SlotEditor';
import { usePendingSlot } from './usePendingSlot';
import { useShallowStore } from '../store/useStore';

const FIELDS = [
  { key: 'mark',   label: 'Mark',   type: 'text'   as const },
  { key: 'width',  label: 'Width',  type: 'number' as const, unit: '"', min: 0 },
  { key: 'height', label: 'Height', type: 'number' as const, unit: '"', min: 0 },
  { key: 'x',      label: 'X Ctr',  type: 'number' as const, unit: '"', min: 0 },
  { key: 'y',      label: 'Y Ctr',  type: 'number' as const, unit: '"', min: 0 },
];

export default function DockLevelersDialog() {
  const { ui, project, updatePanel } = useShallowStore(s => ({
    ui: s.ui, project: s.project, updatePanel: s.updatePanel,
  }));
  const panel = project?.panels.find(p => p.id === ui.activePanelId);
  const [slots, setSlots] = usePendingSlot('dlvar', panel?.dlvar ?? [],
    (px, py, mark) => ({ mark, x: px, y: py }),
    { mark: '', x: 0, y: 0, width: 96, height: 72, depth: 48 });
  if (!panel) return null;

  return (
    <DialogBase title="Dock Levelers (3 max)" onOk={() => updatePanel(panel.id, { dlvar: slots })}>
      <SlotEditor
        slots={slots}
        fields={FIELDS}
        maxSlots={3}
        onChange={v => setSlots(v)}
        defaultData={() => ({ mark: '', x: 0, y: 0, width: 96, height: 72, depth: 48 })}
        label="DL"
      />
    </DialogBase>
  );
}
